
<template>
  <div class="master-detail-card mx-4 mt-3">
    <b-tabs
      v-if="caseData && patId"
      class="vt-tabs cases-detail-tabs"
    >
      <b-tab active>
        <template slot="title">
          {{ $tc('global.sample',2) }} ({{ samplesCount }})
        </template>
        <patient-samples-tab
          ref="sampleTab"
          :cas-id="caseData.id"
          :pat-id="patId"
          @samplesCount="samplesCount=$event"
        />
      </b-tab>
      <b-tab>
        <template
          slot="title"
        >
          {{ $t('component.modalPatientCases.complementaries') }} ({{ complementariesCount }})
        </template>
        <patient-complementaries-tab
          ref="complementaryTab"
          :cas-id="caseData.id"
          @complementariesCount="complementariesCount=$event"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import PatientSamplesTab from '@/components/patientPreviousCases/PatientSamplesTab'
import PatientComplementariesTab from '@/components/patientPreviousCases/PatientComplementariesTab'
import Vue from 'vue'

export default Vue.extend({
    name: 'MyDetailCellRenderer',
    components: {
        PatientSamplesTab,
        PatientComplementariesTab
    },
    data() {
        return {
            caseData: null,
            patId: null,
            samplesCount: 0,
            complementariesCount: 0
        }
    },
    mounted() {
        this.caseData = this.params.data
        this.patId = +this.params.patId
    }
})
</script>

<style lang="scss">
.cases-detail-tabs ::v-deep .tab-content {
  padding: 5px 0 0 0;
}

.patient-cases .ag-full-width-row {
  background: vt-color(light-primary) !important;
  border-top: 1px solid vt-color(primary) !important;
}
</style>

<style lang="scss" scoped>
.master-detail-card {
  height: calc(100% - 30px);
  box-shadow: 1px 1px 5px 0 rgba(125, 125, 125, 0.64);
  border-left: 2px solid vt-color(primary);
  background: #f3f7ff;
}

.cases-detail-tabs {
  padding: 3px 10px;
  height: 100%;
}

.ps-grid {
  padding: 25px;
}
.page_renderer {
  height: 100px;
  text-align: right;
}
.button_row {
  margin: 1% 0 1.5% 0;
}

.button_detail {
  margin-right: 1%;
}
</style>
